import {Aggregator} from "../aggregator";
import React from 'react'
import {AggregateFunctionType} from "../types";
import FieldProto from "../../../fields3/proto/field-proto";

type Props = {
    aggregator: Aggregator
}

export function AggregatorValue(props:Props) {

    switch (props.aggregator.type) {

        case AggregateFunctionType.SUM:
        default:
            return AggregatorSum(props)

    }

}


function AggregatorSum(props:Props) {

    const field:FieldProto = props.aggregator.field

    return (
        <div className="ui5-aggregator-value">
            <div className="icon i5-summary-symbol fs-12" />
            {/*<div className="value">{field.getViewValue({[field.fieldId]: props.aggregator.value})}</div>*/}
            <div className="value">{field.getDisplayValue(props.aggregator.value)}</div>
        </div>

    )
}